// GL6 §4.6 — bir personelin bekleyen bağlantısı için tek satır durum: ikon + metin (renk tek başına taşımaz).
// Tarih BURADA yok: Tarih sütununa `pendingLink.sentAt` yazılır (relevantDate); satır ≈14 karakteri aşmaz.
import { Link2, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { PersonnelActivationLinkDto } from '../api/contractors';

export function PendingLinkLine({ link }: { link: PersonnelActivationLinkDto }) {
  const { t } = useTranslation();
  const expired = link.status === 'Expired';
  const Icon = expired ? TriangleAlert : Link2;
  return (
    <span className="mt-0.5 flex items-center gap-1 text-xs text-muted">
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="truncate">
        <span className="sr-only">{t('personnelLink.field.link')}: </span>
        {expired ? t('personnelLink.pending.expired') : t('personnelLink.pending.sent')}
      </span>
    </span>
  );
}
